export const generatePassword = (): string =>
  `${Math.random().toString(36).substr(2, 8)}`;
